import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';
import { IOptionFM } from '../types';
import DocumentAutoComplete from './DocumentAutoComplete';

interface AddDocumentFormParams {
  onSubmit: any;
  categorys: IOptionFM[];
  suppliers: Option[];
  warehouses: Option[];
}

function AddDocumentForm(params: AddDocumentFormParams) {
  const translationPrefix = 'pages.document.add';
  const { t } = useTranslation();

  const { onSubmit, categorys, suppliers, warehouses } = params;

  return (
    <div>
      <EnhancedForm onSubmit={onSubmit} formId="addNewDocument" hideControls>
        <div className="flex flex-col gap-5 w-full">
          <div className="flex gap-5 w-full">
            <IdentityField
              required
              component={TextFieldAdapter}
              name="name"
              label={t(`${translationPrefix}.name`)}
              type="text"
            />
            <IdentityField
              required
              component={DocumentAutoComplete}
              name="tipology"
              label={t(`${translationPrefix}.tipology`)}
              type="text"
              options={categorys}
            />
          </div>
          <div className="w-full">
            <IdentityField
              component={TextFieldAdapter}
              name="category"
              label={t(`${translationPrefix}.category`)}
              type="text"
            />
          </div>
          <div className="flex gap-5 w-full">
            {suppliers && (
              <div className="w-1/2">
                <IdentityField
                  component={AutocompleteAdapter}
                  name="supplier"
                  label={t('global.supplier')}
                  type="text"
                  options={suppliers}
                />
              </div>
            )}
            <div className={suppliers ? 'w-1/2' : 'w-full'}>
              <IdentityField
                component={AutocompleteAdapter}
                name="warehouse"
                label={t('global.warehouse')}
                type="text"
                options={warehouses}
              />
            </div>
          </div>
          <div className="w-full ">
            <IdentityField
              component={TextFieldAdapter}
              name="description"
              label={t('global.description')}
              type="text"
              multiline
              rows={4}
            />
          </div>
          <div className="">
            <Field name="attachment" required>
              {({ input: { value, onChange, ...input } }) => (
                <input
                  type="file"
                  onChange={({ target }) => onChange(target.files)}
                  style={{ marginBottom: '16px' }}
                  {...input}
                />
              )}
            </Field>
          </div>
        </div>
      </EnhancedForm>
    </div>
  );
}

export default AddDocumentForm;
